import { Link } from 'react-router-dom';

const INTENT_COLUMNS = [
  {
    num: '01',
    category: 'D2C & Luxury Product Video',
    title: 'Product Photos to 4K Commercials — Zero Shoot Required',
    link: '/ai-ugc-agency',
    linkText: 'Explore D2C & AI UGC →',
    items: [
      'Fine Jewellery & Diamond Macro Reels (Rings, Necklaces & Watches)',
      'Footwear & Sneaker Commercials (Bridal Sneakers, Leather Boots & Streetwear)',
      'Fashion Campaigns, Virtual Lookbooks & On-Model Digital Styling',
      'Spirits, Craft Liquor Bottles & Beverage Launch Spots (Alcobrew BHRUM)',
      'Amazon, Shopify & Quick-Commerce PDP Listing Videos at SKU Scale',
    ],
  },
  {
    num: '02',
    category: 'Paid Social & Agency White-Label',
    title: 'Done-For-You AI UGC & White-Label Agency Partner',
    link: '/ai-ugc-agency',
    linkText: 'Explore Agency Retainers →',
    items: [
      '9:16 AI Creator & Spokesperson Ads for Meta, TikTok & YouTube Shorts',
      'Multi-Hook A/B Testing Ad Variations for DTC Performance Marketing',
      'White-Label AI Video Production for Marketing & Creative Agencies',
      'Fintech, App Install & SaaS Explainer UGC Spots without Booking Creators',
      'Turnkey Script-to-Master Delivery in 3–5 Days with Clean Unbranded Masters',
    ],
  },
  {
    num: '03',
    category: 'Hybrid Live-Action VFX Fixes',
    title: 'Camera Plate Relighting, Crowd & Set Extension',
    link: '/ai-vfx',
    linkText: 'Explore Hybrid VFX →',
    items: [
      'Green-Screen to 40,000-Seat Floodlit Stadium Crowd Synthesis',
      'Beeble SwitchX 4K Neural Relighting (Overcast Day to Golden-Hour Sunset)',
      'Bare Studio Wall & Blue-Screen to Sunlit Interiors or Automated Factories',
      'Frame-Consistent AI Facial Age-Progression & Character De-Aging VFX',
      '2K/4K ProRes 4444, EXR & ACES Color Pipeline for Nuke & DaVinci Resolve',
    ],
  },
  {
    num: '04',
    category: '9:16 Vertical Entertainment',
    title: 'Serialized Vertical Micro-Dramas for Streaming Apps',
    link: '/micro-drama-production',
    linkText: 'Explore Micro-Dramas →',
    items: [
      'Commissioned 60–100 Episode 9:16 Vertical Series for DramaBox & Dashverse',
      'Multi-Shot Character Identity Lock (Consistent Faces, Wardrobe & Locations)',
      'Action, Sci-Fi Siege, Neo-Noir Thriller & Billionaire/Romance Verticals',
      'Branded Episodic Micro-Dramas for Mobile-First Consumer Campaigns',
      'ComfyUI + RealESRGAN 1080p/4K Vertical Finishing & Episodic Sound Design',
    ],
  },
  {
    num: '05',
    category: 'Cinema, Previs & Pitch Trailers',
    title: 'Feature Film VFX, AI Previs & OTT Pitch Reels',
    link: '/ai-filmmaking',
    linkText: 'Explore Filmmaking →',
    items: [
      'Telugu & Indian Theatrical Feature Film VFX (#CULT, HONEY, MANODU G.O.A.T)',
      'AI Previsualization (AI Previs), Storyboards & Animatics for Directors',
      'OTT Greenlight Pitch Trailers & Proof-of-Concept Sizzle Reels',
      'Mythological Epics (Jatayu), Action Thrillers (Ashes of Fire) & Sci-Fi Shorts',
      'Official 4K AI Music Videos & Visualizers for Record Labels & Artists',
    ],
  },
  {
    num: '06',
    category: 'Global & Regional Campaigns',
    title: 'GCC / Middle East, US, UK & India Production Hub',
    link: '/ai-commercials-ugc',
    linkText: 'Explore Brand Work →',
    items: [
      'Ramadan & Seasonal Broadcast Commercials for UAE, Bahrain & Saudi Arabia (BKIC)',
      'Luxury Real Estate, Waterfront & Architectural Brand Films (Seef Properties)',
      'Electric SUV & Automotive Launch Commercials without Vehicle Shipping (XPENG G9)',
      'Multi-Model Stack: Seedance 2.0, Kling, Veo 3, Runway Gen-4 & Beeble SwitchX',
      'Hyderabad Production & R&D Hub Serving US, UK, Europe & MENA Agencies',
    ],
  },
];

export default function SearchIntentDirectory() {
  return (
    <section
      id="use-cases"
      className="bg-black py-20 sm:py-28 border-t border-white/[0.08] w-full"
    >
      <div className="w-full px-5 sm:px-10 lg:px-16 xl:px-24">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 pb-10 border-b border-white/[0.08]">
          <div className="max-w-3xl">
            <p className="text-[11px] font-mono uppercase tracking-[0.14em] text-[#E50914] mb-2">
              ● Specialized Production Verticals &amp; Technical Workflows
            </p>
            <h2 className="text-white font-normal tracking-[-0.03em] leading-[1.05] text-[clamp(1.75rem,3.3vw,3.15rem)]">
              Built for specific briefs, industries &amp; production bottlenecks.
            </h2>
          </div>
          <p className="text-[#767d88] text-sm sm:text-[15px] max-w-md">
            From macro diamond jewellery reels and white-label agency UGC to Beeble SwitchX
            plate relighting and 9:16 micro-drama slates.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 pt-10">
          {INTENT_COLUMNS.map((col) => (
            <article
              key={col.num}
              className="p-6 sm:p-7 rounded-xl bg-[#070709] border border-white/[0.08] hover:border-white/20 transition-colors flex flex-col justify-between"
            >
              <div>
                <div className="flex items-center justify-between gap-2 text-[11px] font-mono mb-3">
                  <span className="text-[#E50914] font-semibold">{col.num}</span>
                  <span className="text-[#767d88] uppercase tracking-[0.08em]">
                    {col.category}
                  </span>
                </div>

                <h3 className="text-[18px] sm:text-[19px] font-medium tracking-[-0.02em] text-white leading-snug mb-4">
                  {col.title}
                </h3>

                <ul className="space-y-2.5 text-[13px] text-[#8a909a] leading-relaxed list-none p-0 m-0">
                  {col.items.map((item) => (
                    <li key={item} className="flex items-start gap-2">
                      <span className="text-[#E50914] mt-1 text-[10px]">●</span>
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="mt-6 pt-4 border-t border-white/[0.06]">
                <Link
                  to={col.link}
                  className="text-[12px] font-mono uppercase tracking-[0.08em] text-white/80 hover:text-[#E50914] transition-colors no-underline"
                >
                  {col.linkText}
                </Link>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
